import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { TextInputComponent } from '../../../form-components/text-input/text-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-table-header-text-input',
  templateUrl: '../../../../ui/form-components/text-input/text-input.component.html',
  styleUrls: ['./table-header-text-input.component.scss', '../table-column-inputs.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableHeaderTextInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: []
})
export class TableHeaderTextInputComponent extends TextInputComponent {
  @Input() placeholder: string = $localize`Search`;
}
